import { render } from "./LoanRepayment.vue?vue&type=template&id=97cf6a12&scoped=true"
import script from "./LoanRepayment.vue?vue&type=script&lang=js"
export * from "./LoanRepayment.vue?vue&type=script&lang=js"

import "./LoanRepayment.vue?vue&type=style&index=0&id=97cf6a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cf6a12"]])

export default __exports__